// import React, { useEffect, useState } from "react"
// import { Table, Card, CardBody, Col, Row, Button, Input } from "reactstrap"

// import { useNavigate } from "react-router-dom"
// import Select from "react-select"
// import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
// import secureLocalStorage from "react-secure-storage"
// import { DigitalServiceOptionsDrop } from "utils/common-options"
// import moment from "moment"
// import Loader from "pages/Separate/Loader"

// const SEORankingRecord = () => {
//   const [projectOptions, setProjectOptions] = useState([])
//   const [project, setProject] = useState(null)
//   const [keywords, setKeywords] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [currentTab, setCurrentTab] = useState(false)
//   const [image, setImage] = useState(null)

//   const [extraKeywords, setExtraKeywords] = useState([])

//   const token = secureLocalStorage.getItem("token")

//   /* ================= 4. PERFORMANCE – ORDERS ================= */
//   const [ordersPerformance, setOrdersPerformance] = useState({
//     totalOrders: { title: "Total Orders", value: "", subtitle: "", reason: "" },
//     totalOrderValue: {
//       title: "Total Order Value",
//       value: "",
//       subtitle: "",
//       reason: "",
//     },
//     avgOrderValue: {
//       title: "Avg Order Value",
//       value: "",
//       subtitle: "",
//       reason: "",
//     },
//   })

//   /* ================= 5. CAMPAIGN PERFORMANCE ================= */
//   const [campaigns, setCampaigns] = useState([
//     { title: "", description: "", link: null },
//   ])

//   const [performanceComparison, setPerformanceComparison] = useState([
//     {
//       metric: "Total Website Visits",
//       current: "",
//       last: "0",
//       percentage: "",
//       trend: "", // up / down
//       fixed: true,
//     },
//     {
//       metric: "Organic Traffic",
//       current: "",
//       last: "0",
//       percentage: "",
//       trend: "",
//       fixed: true,
//     },
//     {
//       metric: "Direct Traffic",
//       current: "",
//       last: "0",
//       percentage: "",
//       trend: "",
//       fixed: true,
//     },
//     {
//       metric: "Referral Traffic",
//       current: "",
//       last: "0",
//       percentage: "",
//       trend: "",
//       fixed: true,
//     },
//     {
//       metric: "Time Spent on Site",
//       current: "",
//       last: "0",
//       percentage: "",
//       trend: "",
//       fixed: true,
//     },
//   ])

//   /* ================= 6. Local SEO PERFORMANCE ================= */
//   const [localSeoPerformance, setLocalSeoPerformance] = useState([
//     {
//       google_buisness: "",
//       interactions: "",
//       calls: "",
//       directions: "",
//       Click: "",
//       link: null,
//     },
//   ])

//   const [isOrders, setIsOrders] = useState(false)
//   const [tempMonth, setTempMonth] = useState("01")

//   // ================= API CALLING ===================
//   // get projects list
//   useEffect(() => {
//     ; (async () => {
//       try {
//         const projectsRes = await fetchNodeData(
//           null,
//           `seoReport/getProjectKS`,
//           token
//         )

//         const projectsOptions = (projectsRes.data || []).map(item => ({
//           value: item.id,
//           label: item.project_name,
//           services: DigitalServiceOptionsDrop.filter(
//             s =>
//               (item.project_type || "")?.includes(s.value) &&
//               (s.value == "1" || s.value == "3")
//           ),
//           seo_keywords: item.seo_keywords || "",
//         }))
//         setProjectOptions(projectsOptions)
//       } catch (error) {
//         console.log("Error Calling API : ", error)
//       }
//     })()
//   }, [])

//   // set keywords projectwise
//   useEffect(() => {
//     if (project) {
//       setKeywords(
//         project.seo_keywords
//           ?.split(",")
//           ?.filter(item => item)
//           ?.map(keyword => ({ keyword: keyword, rank: "" })) || []
//       )
//     }
//     console.log(project)
//   }, [project])

//   const updatePerformanceRow = (index, field, value) => {
//     const updated = [...performanceComparison]
//     updated[index][field] = value

//     if (field === "current" || field === "last") {
//       const { percentage, trend } = calculateChange(
//         Number(updated[index].current),
//         Number(updated[index].last)
//       )
//       updated[index].percentage = percentage
//       updated[index].trend = trend
//     }

//     setPerformanceComparison(updated)
//   }

//   // upload images for local seo and campaigns
//   // const handleUploadImage = async (e, setData, index) => {
//   //   try {
//   //     // const formData = new FormData()
//   //     // formData.append("file", e.target.files[0])

//   //     // const res2 = await axios.post(
//   //     //   `${configure.nodeApi}/uploadImgToOneDrive`,
//   //     //   formData
//   //     // )

//   //     // if (res2?.data?.success) {
//   //     //   setData(prev => {
//   //     //     return prev.map((item, i) => {
//   //     //       if (i === index) item.link = res2?.data?.link || ""

//   //     //       return item
//   //     //     })
//   //     //   })
//   //     // }

//   //     const imgUrl = URL.createObjectURL(e.target.files[0])

//   //     setData(prev => {
//   //       return prev.map((item, i) => {
//   //         if (i === index) item.link = imgUrl || ""
//   //         return item
//   //       })
//   //     })
//   //   } catch (error) {
//   //     console.log(error)
//   //   }
//   // }

//   // for traffic trend calculation

//   const fileToBase64 = file =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader()
//       reader.readAsDataURL(file)
//       reader.onload = () => resolve(reader.result)
//       reader.onerror = error => reject(error)
//     })

//   const handleUploadImage = async (e, setData, index) => {
//     const file = e.target.files[0]
//     if (!file) return

//     const base64 = await fileToBase64(file)

//     // save base64 wherever you want
//     setData(prev => {
//       return prev.map((item, i) => {
//         if (i === index) item.link = base64 || ""
//         return item
//       })
//     })
//   }

//   const handleNegativeValue = (section, key, field, value) => {
//     setOrdersPerformance(prev => ({
//       ...prev,
//       [key]: {
//         ...prev[key],
//         [field]: value,
//         reason: value < 0 ? prev[key].reason : "",
//       },
//     }))
//   }


//   const calculateChange = (current, last) => {
//     if (!current || !last || Number(last) === 0) {
//       return { percentage: "", trend: "" }
//     }

//     const diff = ((current - last) / last) * 100
//     return {
//       percentage: Math.abs(diff).toFixed(2),
//       trend: diff >= 0 ? "up" : "down",
//     }
//   }

//   // save keywords ranking
//   const handleSaveKeywordRanking = async () => {
//     if (
//       keywords.some(item => !item.rank) ||
//       extraKeywords.some(item => item.keyword && !item.rank) ||
//       extraKeywords.some(item => !item.keyword && !item.rank)
//     ) {
//       swal("", "Ranking for all keywords is required.", "warning")
//       return
//     }

//     swal({
//       title: "Are you sure?",
//       text: `You want to save today's keyword ranking for ${project?.label}`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {
//         try {
//           const formData = {
//             id: project.value,
//             keywordRanking: JSON.stringify(keywords),
//             additionalKeyword: JSON.stringify(extraKeywords),
//             date: moment().format("YYYY-MM-DD"),
//           }
//           const res = await FetchNodePostData(
//             setLoading,
//             `seoReport/addKeywordRanking`,
//             token,
//             formData
//           )

//           if (res?.data?.success) {
//             // setProject(null)
//             // setExtraKeywords([])
//             swal("", "Ranking recorded successfully", "success")
//           } else {
//             swal(
//               "",
//               res?.response?.data?.message ||
//               res.message ||
//               "Something Went Wrong!",
//               "warning"
//             )
//           }

//           // console.log(res)
//         } catch (error) {
//           console.log(error, "Something Went Wrong")
//           swal(
//             "",
//             error?.response?.data?.message ||
//             error.message ||
//             "Something Went Wrong!",
//             "error"
//           )
//         }
//       }
//     })
//   }

//   // save Local SEo
//   const handleSaveLocalSeo = async () => {
//     if (
//       localSeoPerformance.some(item => {
//         return (
//           !item.google_buisness.trim() ||
//           !item.interactions.trim() ||
//           !item.calls.trim() ||
//           !item.directions.trim() ||
//           !item.Click.trim() ||
//           !item.link
//         )
//       })
//     ) {
//       swal("", "All data required!", "warning")
//       return
//     }

//     swal({
//       title: "Are you sure?",
//       text: `You want to save today's Local SEO Performance for ${project?.label}`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {
//         try {
//           const formData = {
//             project_id: project.value,
//             local_seo: localSeoPerformance,
//             date: moment().format("YYYY-MM-DD"),
//           }
//           const res = await FetchNodePostData(
//             setLoading,
//             `seoReport/addLocalSeo`,
//             token,
//             formData
//           )

//           if (res?.data?.success) {
//             setLocalSeoPerformance(
//               [
//                 {
//                   google_buisness: "",
//                   interactions: "",
//                   calls: "",
//                   directions: "",
//                   Click: "",
//                   link: null,
//                 },
//               ]
//             )
//             swal("", "Data recorded successfully", "success")
//           } else {
//             swal(
//               "",
//               res?.response?.data?.message ||
//               res.message ||
//               "Something Went Wrong!",
//               "warning"
//             )
//           }

//           // console.log(res)
//         } catch (error) {
//           console.log(error, "Something Went Wrong")
//           swal(
//             "",
//             error?.response?.data?.message ||
//             error.message ||
//             "Something Went Wrong!",
//             "error"
//           )
//         }
//       }
//     })
//   }

//   // save Traffic
//   const handleSaveTraffic = async () => {
//     if (performanceComparison.some(item => !item.current.trim())) {
//       swal("", "All data required!", "warning")
//       return
//     }

//     swal({
//       title: "Are you sure?",
//       text: `You want to save today's Traffic Comparison for ${project?.label}`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {
//         try {
//           const formData = {
//             project_id: project.value,
//             visits: performanceComparison[0]?.current,
//             organic: performanceComparison[1]?.current,
//             direct: performanceComparison[2]?.current,
//             referral: performanceComparison[3]?.current,
//             time_spent: performanceComparison[4]?.current,
//             date: moment().format("YYYY-MM-DD"),
//             month: tempMonth,
//             image: image
//           }
//           const res = await FetchNodePostData(
//             setLoading,
//             `seoReport/addWebsiteTraffic`,
//             token,
//             formData
//           )

//           if (res?.data?.success) {
//             setPerformanceComparison(
//               [
//                 {
//                   metric: "Total Website Visits",
//                   current: "",
//                   last: "130",
//                   percentage: "",
//                   trend: "", // up / down
//                   fixed: true,
//                 },
//                 {
//                   metric: "Organic Traffic",
//                   current: "",
//                   last: "78",
//                   percentage: "",
//                   trend: "",
//                   fixed: true,
//                 },
//                 {
//                   metric: "Direct Traffic",
//                   current: "",
//                   last: "22",
//                   percentage: "",
//                   trend: "",
//                   fixed: true,
//                 },
//                 {
//                   metric: "Referral Traffic",
//                   current: "",
//                   last: "30",
//                   percentage: "",
//                   trend: "",
//                   fixed: true,
//                 },
//                 {
//                   metric: "Time Spent on Site",
//                   current: "",
//                   last: "1.05",
//                   percentage: "",
//                   trend: "",
//                   fixed: true,
//                 },
//               ]
//             )
//             setImage(null)
//             swal("", "Data recorded successfully", "success")
//           } else {
//             swal(
//               "",
//               res?.response?.data?.message ||
//               res.message ||
//               "Something Went Wrong!",
//               "warning"
//             )
//           }

//           // console.log(res)
//         } catch (error) {
//           console.log(error, "Something Went Wrong")
//           swal(
//             "",
//             error?.response?.data?.message ||
//             error.message ||
//             "Something Went Wrong!",
//             "error"
//           )
//         }
//       }
//     })
//   }

//   // save Orders
//   const handleSaveOrders = async () => {
//     if (false) {
//       swal("", "Ranking for all keywords is required.", "warning")
//       return
//     }

//     swal({
//       title: "Are you sure?",
//       text: `You want to save today's Order Performance for ${project?.label}`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {
//         try {
//           const formData = {
//             project_id: project.value,
//             totalOrders: ordersPerformance.totalOrders,
//             totalOrderValue: ordersPerformance.totalOrderValue,
//             avgOrderValue: ordersPerformance.avgOrderValue,
//             date: moment().format("YYYY-MM-DD"),
//           }
//           const res = await FetchNodePostData(
//             setLoading,
//             `seoReport/addPerformaceReport`,
//             token,
//             formData
//           )

//           if (res?.data?.success) {
//             setOrdersPerformance(
//               {
//                 totalOrders: { title: "Total Orders", value: "", subtitle: "", reason: "" },
//                 totalOrderValue: {
//                   title: "Total Order Value",
//                   value: "",
//                   subtitle: "",
//                   reason: "",
//                 },
//                 avgOrderValue: {
//                   title: "Avg Order Value",
//                   value: "",
//                   subtitle: "",
//                   reason: "",
//                 },
//               }
//             )
//             swal("", "Data recorded successfully", "success")
//           } else {
//             swal(
//               "",
//               res?.response?.data?.message ||
//               res.message ||
//               "Something Went Wrong!",
//               "warning"
//             )
//           }

//           // console.log(res)
//         } catch (error) {
//           console.log(error, "Something Went Wrong")
//           swal(
//             "",
//             error?.response?.data?.message ||
//             error.message ||
//             "Something Went Wrong!",
//             "error"
//           )
//         }
//       }
//     })
//   }

//   // save Local SEo
//   const handleSaveCampaign = async () => {
//     if (false) {
//       swal("", "All Seo data is required.", "warning")
//       return
//     }

//     swal({
//       title: "Are you sure?",
//       text: `You want to save today's Campaign for ${project?.label}`,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {

//         try {
//           const formData = {
//             project_id: project.value,
//             campaigns: campaigns,
//             date: moment().format("YYYY-MM-DD"),
//           }
//           const res = await FetchNodePostData(
//             setLoading,
//             `seoReport/addCampain`,
//             token,
//             formData
//           )

//           if (res?.data?.success) {
//             setCampaigns(
//               [
//                 { title: "", description: "", link: null },
//               ]
//             )
//             swal("", "Data recorded successfully", "success")
//           } else {
//             swal(
//               "",
//               res?.response?.data?.message ||
//               res.message ||
//               "Something Went Wrong!",
//               "warning"
//             )
//           }

//           // console.log(res)
//         } catch (error) {
//           console.log(error, "Something Went Wrong")
//           swal(
//             "",
//             error?.response?.data?.message ||
//             error.message ||
//             "Something Went Wrong!",
//             "error"
//           )
//         }
//       }
//     })
//   }

//   // console.log(project?.services)
//   return (
//     <>
//       {loading && <Loader />}
//       <Card className="mb-4 audit_box">
//         <CardBody>
//           <div>
//             <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
//               <h5 className="text-purple">SEO Keyword Ranking</h5>
//             </div>

//             <div className="row align-items-start">
//               <div className="col-3">
//                 <label htmlFor="">Select Project</label>
//                 <Select
//                   placeholder="Select Project"
//                   className="basic-multi-select"
//                   classNamePrefix="select"
//                   options={projectOptions}
//                   value={project}
//                   onChange={e => {
//                     setProject(e)
//                     if (e.services.length) setCurrentTab(e.services[0].value)
//                   }}
//                   required
//                 />
//               </div>
//               <div className="col-2">
//                 {project?.services && (
//                   <div>
//                     <label htmlFor="">Services</label>

//                     <div className="d-flex gap-3 align-items-center">
//                       {project?.services?.filter(item => item.value == "1")?.map(item => (
//                         <div
//                           key={item.value}
//                           onClick={() => setCurrentTab(item.value)}
//                           className={`px-4 py-2 rounded-pill bg-${currentTab == item.value ? "purple" : "white"
//                             } fw-semibold`}
//                           style={{ userSelect: "none", cursor: "pointer" }}
//                         >
//                           {item.label}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="col-6 text-end">
//                 {/* <button
//                   onClick={handleSaveKeywordRanking}
//                   type="button"
//                   className=" btn text-white btn-save btn-label ms-3"
//                 >
//                   <i className="fas fa-save me-2 icon-size label-icon"></i>
//                   Save
//                 </button> */}
//               </div>
//             </div>
//           </div>
//         </CardBody>
//       </Card>

//       {project && (
//         <>
//           {currentTab == "1" && (
//             <>
//               {/* KEYWORD POSITION SUMMARY */}
//               <Card className="mb-4 audit_box">
//                 <CardBody>
//                   <div className="d-flex justify-content-between align-items-center">
//                     <h5 className="mb-3 text-purple ">
//                       Fixed Keyword & Ranking
//                     </h5>

//                     <button
//                       onClick={handleSaveKeywordRanking}
//                       type="button"
//                       className=" btn text-white btn-save btn-label ms-3"
//                     >
//                       <i className="fas fa-save me-2 icon-size label-icon"></i>
//                       Save
//                     </button>
//                   </div>
//                   {keywords.map((k, i) => (
//                     <Row key={i} className="mb-2">
//                       <Col md={6}>
//                         <Input
//                           placeholder="Keyword"
//                           value={k.keyword}
//                           readOnly
//                         />
//                       </Col>
//                       <Col md={2}>
//                         <Input
//                           placeholder="Ranking"
//                           type="number"
//                           value={k.rank}
//                           onChange={e => {
//                             const updated = [...keywords]
//                             updated[i].rank = e.target.value
//                             setKeywords(updated)
//                           }}
//                         />
//                       </Col>
//                     </Row>
//                   ))}

//                   {!keywords.length && (
//                     <span className="text-secondary">
//                       No keyword available!
//                     </span>
//                   )}

//                   <h5 className="mt-5 mb-3 text-purple ">
//                     Any Additional Keyword & Ranking ?
//                     <Button
//                       color="primary"
//                       onClick={() =>
//                         setExtraKeywords([
//                           ...extraKeywords,
//                           { keyword: "", rank: "" },
//                         ])
//                       }
//                       className="btn-dark border-0 ms-4 py-1"
//                     >
//                       <i className="fas fa-plus me-1"></i> Keyword
//                     </Button>
//                   </h5>
//                   {extraKeywords.map((k, i) => (
//                     <Row key={i} className="mb-2">
//                       <Col md={6}>
//                         <Input
//                           placeholder="Keyword"
//                           value={k.keyword}
//                           onChange={e => {
//                             const updated = [...extraKeywords]
//                             updated[i].keyword = e.target.value

//                             if (!e.target.value) {
//                               updated[i].rank = ""
//                             }

//                             setExtraKeywords(updated)
//                           }}
//                         />
//                       </Col>
//                       <Col md={2}>
//                         <Input
//                           placeholder="Ranking"
//                           type="number"
//                           value={k.rank}
//                           onChange={e => {
//                             const updated = [...extraKeywords]
//                             updated[i].rank = e.target.value
//                             setExtraKeywords(updated)
//                           }}
//                           readOnly={!k.keyword}
//                         />
//                       </Col>
//                       <Col md={4}>
//                         <Button
//                           color="danger"
//                           onClick={() =>
//                             setExtraKeywords(
//                               extraKeywords.filter((_, idx) => idx !== i)
//                             )
//                           }
//                           className="me-3 btn-red border-0"
//                         >
//                           <i className="fas fa-trash"></i>
//                         </Button>
//                       </Col>
//                     </Row>
//                   ))}
//                 </CardBody>
//               </Card>

//               {/* LOCAL SEO PERFORMANCE */}
//               <Card className="mb-4 audit_box">
//                 <CardBody>
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h5 className=" text-purple ">Local SEO Performance</h5>

//                     <button
//                       onClick={handleSaveLocalSeo}
//                       type="button"
//                       className=" btn text-white btn-save btn-label ms-3"
//                     >
//                       <i className="fas fa-save me-2 icon-size label-icon"></i>
//                       Save
//                     </button>
//                   </div>

//                   <Table bordered className="bg-white">
//                     <thead>
//                       <tr>
//                         <th>Google My Business</th>
//                         <th className="col-1">Interaction</th>
//                         <th className="col-1">Call</th>
//                         <th className="col-1">Direction</th>
//                         <th className="col-1">Click</th>
//                         <th className="col-2">ScreenShot</th>
//                         <th></th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {localSeoPerformance.map((row, i) => (
//                         <tr key={i}>
//                           <td>
//                             <Input
//                               value={row.google_buisness}
//                               placeholder="Enter here.."
//                               onChange={e => {
//                                 const updated = [...localSeoPerformance]
//                                 updated[i].google_buisness = e.target.value
//                                 setLocalSeoPerformance(updated)
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Input
//                               value={row.interactions}
//                               onChange={e => {
//                                 const updated = [...localSeoPerformance]
//                                 updated[i].interactions = e.target.value
//                                 setLocalSeoPerformance(updated)
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Input
//                               value={row.calls}
//                               onChange={e => {
//                                 const updated = [...localSeoPerformance]
//                                 updated[i].calls = e.target.value
//                                 setLocalSeoPerformance(updated)
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Input
//                               value={row.directions}
//                               onChange={e => {
//                                 const updated = [...localSeoPerformance]
//                                 updated[i].directions = e.target.value
//                                 setLocalSeoPerformance(updated)
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Input
//                               value={row.Click}
//                               onChange={e => {
//                                 const updated = [...localSeoPerformance]
//                                 updated[i].Click = e.target.value
//                                 setLocalSeoPerformance(updated)
//                               }}
//                             />
//                           </td>
//                           <td className="d-flex gap-3 align-items-center">
//                             <input
//                               type="file"
//                               className="form-control"
//                               onChange={e =>
//                                 handleUploadImage(e, setLocalSeoPerformance, i)
//                               }
//                             />
//                             {row.link ? (
//                               <img src={row.link} width={30} height={30} />
//                             ) : null}
//                           </td>
//                           <td className="col-2">
//                             {i !== 0 && (
//                               <Button
//                                 color="danger"
//                                 onClick={() =>
//                                   setLocalSeoPerformance(
//                                     localSeoPerformance.filter(
//                                       (_, idx) => idx !== i
//                                     )
//                                   )
//                                 }
//                                 className="me-3 btn-red border-0"
//                               >
//                                 <i className="fas fa-trash"></i>
//                               </Button>
//                             )}

//                             {i == localSeoPerformance.length - 1 && (
//                               <Button
//                                 color="primary"
//                                 onClick={() =>
//                                   setLocalSeoPerformance([
//                                     ...localSeoPerformance,
//                                     {
//                                       google_buisness: "",
//                                       interactions: "",
//                                       calls: "",
//                                       directions: "",
//                                       Click: "",
//                                       link: null,
//                                     },
//                                   ])
//                                 }
//                                 className="btn-purple border-0"
//                               >
//                                 <i className="fas fa-plus me-1"></i> New
//                               </Button>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </CardBody>
//               </Card>

//               <Card className="mb-4 audit_box">
//                 <CardBody>
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     {/* <h5 className=" text-purple ">
//                       Website Traffic Comparison from Last Month
//                     </h5> */}

//                     <h5 className=" text-purple d-flex gap-4">
//                       Website Traffic Comparison from Last Month
//                       <select
//                         className="form-select w-25"
//                         value={tempMonth}
//                         onChange={e => setTempMonth(e.target.value)}
//                       >
//                         <option value="01">January - 2026</option>
//                         <option value="12">December - 2025</option>
//                       </select>
//                     </h5>

//                     <div className="d-flex align-items-center gap-3">
//                       <div className="">
//                         <input
//                           type="file"
//                           className="form-control"
//                           style={{ width: '250px' }}
//                           onChange={async (e) => {
//                             const file = e.target.files[0];
//                             if (file) {
//                               const baseimage = await fileToBase64(file);
//                               setImage(baseimage);
//                             }
//                           }}
//                         />
//                       </div>
//                       {image ? (
//                         <img src={image} width={30} height={30} />
//                       ) : null}
//                       <div>
//                         <button
//                           onClick={handleSaveTraffic}
//                           type="button"
//                           className=" btn text-white btn-save btn-label ms-3"
//                         >
//                           <i className="fas fa-save me-2 icon-size label-icon"></i>
//                           Save
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   <Table bordered responsive className="bg-white">
//                     <thead>
//                       <tr>
//                         <th>Metric</th>
//                         <th className="col-2">Current Month</th>
//                         {/* <th className="col-1">Last Month</th>
//                         <th className="col-1">Change %</th>
//                         <th className="col-1 text-center">Trend</th> */}
//                         {/* <th></th> */}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {performanceComparison.map((row, i) => (
//                         <tr key={i}>
//                           <td>
//                             <Input
//                               value={row.metric}
//                               disabled={row.fixed}
//                               onChange={e =>
//                                 updatePerformanceRow(
//                                   i,
//                                   "metric",
//                                   e.target.value
//                                 )
//                               }
//                             />
//                           </td>

//                           <td>
//                             <Input
//                               type="text"
//                               value={row.current}
//                               onChange={e =>
//                                 updatePerformanceRow(
//                                   i,
//                                   "current",
//                                   e.target.value
//                                 )
//                               }
//                             />
//                           </td>

//                           {/* <td>
//                             <Input
//                               type="text"
//                               value={row.last}
//                               readOnly
//                               onChange={e =>
//                                 updatePerformanceRow(i, "last", e.target.value)
//                               }
//                             />
//                           </td>

//                           <td>
//                             <Input value={row.percentage || "--"} readOnly />
//                           </td>

//                           <td className="text-center fs-5">
//                             {row.trend === "up" && (
//                               <span style={{ color: "green" }}>↑</span>
//                             )}
//                             {row.trend === "down" && (
//                               <span style={{ color: "red" }}>↓</span>
//                             )}
//                           </td> */}

//                           {/* <td className="col-2">
//                                           {!row.fixed && (
//                                             <Button
//                                               color="danger"
//                                               onClick={() =>
//                                                 setPerformanceComparison(
//                                                   performanceComparison.filter(
//                                                     (_, idx) => idx !== i
//                                                   )
//                                                 )
//                                               }
//                                               className="me-3 btn-red border-0"
//                                             >
//                                               <i className="fas fa-trash"></i>
//                                             </Button>
//                                           )}
              
//                                           {i == performanceComparison.length - 1 && (
//                                             <Button
//                                               color="primary"
//                                               onClick={() =>
//                                                 setPerformanceComparison([
//                                                   ...performanceComparison,
//                                                   {
//                                                     metric: "",
//                                                     current: "",
//                                                     last: "0",
//                                                     percentage: "",
//                                                     trend: "",
//                                                     fixed: false,
//                                                   },
//                                                 ])
//                                               }
//                                               className="btn-purple border-0"
//                                             >
//                                               <i className="fas fa-plus me-1"></i> Metric
//                                             </Button>
//                                           )}
//                                         </td> */}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </CardBody>
//               </Card>
//             </>
//           )}

//           {/* PERFORMANCE BREAKDOWN */}
//           {currentTab == "3" && (
//             <Card className="mb-4 audit_box">
//               <CardBody>
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h5 className=" text-purple ">Performance Breakdown of All Campaigns</h5>

//                   <button
//                     onClick={handleSaveCampaign}
//                     type="button"
//                     className=" btn text-white btn-save btn-label ms-3"
//                   >
//                     <i className="fas fa-save me-2 icon-size label-icon"></i>
//                     Save
//                   </button>
//                 </div>

//                 <Table bordered className="bg-white">
//                   <thead>
//                     <tr>
//                       <th>Campaign</th>
//                       <th>Description</th>
//                       <th className="col-3">ScreenShot</th>
//                       <th></th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {campaigns.map((row, i) => (
//                       <tr key={i}>
//                         <td>
//                           <Input
//                             value={row.title}
//                             placeholder="Enter title"
//                             onChange={e => {
//                               const updated = [...campaigns]
//                               updated[i].title = e.target.value
//                               setCampaigns(updated)
//                             }}
//                           />
//                         </td>
//                         <td>
//                           <Input
//                             placeholder="Enter description"
//                             value={row.description}
//                             onChange={e => {
//                               const updated = [...campaigns]
//                               updated[i].description = e.target.value
//                               setCampaigns(updated)
//                             }}
//                           />
//                         </td>
//                         <td className="d-flex gap-3 align-items-center">
//                           <Input
//                             type="file"
//                             onChange={e =>
//                               handleUploadImage(e, setCampaigns, i)
//                             }
//                           />
//                           {row.link ? (
//                             <img src={row.link} width={30} height={30} />
//                           ) : null}
//                         </td>
//                         <td className="col-2">
//                           {i !== 0 && (
//                             <Button
//                               color="danger"
//                               onClick={() =>
//                                 setCampaigns(
//                                   campaigns.filter((_, idx) => idx !== i)
//                                 )
//                               }
//                               className="me-3 btn-red border-0"
//                             >
//                               <i className="fas fa-trash"></i>
//                             </Button>
//                           )}

//                           {i == campaigns.length - 1 && (
//                             <Button
//                               color="primary"
//                               onClick={() =>
//                                 setCampaigns([
//                                   ...campaigns,
//                                   {
//                                     title: "",
//                                     description: "",
//                                     link: null,
//                                   },
//                                 ])
//                               }
//                               className="btn-purple border-0"
//                             >
//                               <i className="fas fa-plus me-1"></i> Campaign
//                             </Button>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </CardBody>
//             </Card>
//           )}

//           {/* PERFORMANCE – ORDERS */}
//           <Card className="mb-4 audit_box">
//             <CardBody>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="fw-semibold text-purple mb-3 d-flex gap-4">
//                   Performance – Primary Goal: Orders
//                   <div className="form-switch form-switch-md">
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       checked={isOrders}
//                       onClick={e => {
//                         setIsOrders(!e.target.checked)
//                       }}
//                     />
//                   </div>
//                 </h5>
//                 {isOrders && (
//                   <button
//                     onClick={handleSaveOrders}
//                     type="button"
//                     className=" btn text-white btn-save btn-label ms-3"
//                   >
//                     <i className="fas fa-save me-2 icon-size label-icon"></i>
//                     Save
//                   </button>
//                 )}
//               </div>
//               {isOrders
//                 ? Object.entries(ordersPerformance).map(([key, data]) => (
//                   <Row key={key} className="mb-3">
//                     <Col md={2}>
//                       <h5 className="mb-0 pt-2">{data.title}</h5>
//                     </Col>

//                     <Col md={2}>
//                       <Input
//                         type="number"
//                         placeholder="Value"
//                         value={data.value}
//                         onChange={e =>
//                           handleNegativeValue(
//                             "orders",
//                             key,
//                             "value",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </Col>

//                     <Col md={4}>
//                       <Input
//                         placeholder="Subtitle"
//                         value={data.subtitle}
//                         onChange={e =>
//                           setOrdersPerformance(prev => ({
//                             ...prev,
//                             [key]: {
//                               ...prev[key],
//                               subtitle: e.target.value,
//                             },
//                           }))
//                         }
//                       />
//                     </Col>

//                     {data.value < 0 && (
//                       <Col md={4}>
//                         <Input
//                           placeholder="Reason for negative value"
//                           value={data.reason}
//                           onChange={e =>
//                             setOrdersPerformance(prev => ({
//                               ...prev,
//                               [key]: {
//                                 ...prev[key],
//                                 reason: e.target.value,
//                               },
//                             }))
//                           }
//                         />
//                       </Col>
//                     )}
//                   </Row>
//                 ))
//                 : null}
//             </CardBody>
//           </Card>
//         </>
//       )}
//     </>
//   )
// }

// export default SEORankingRecord



import React, { useEffect, useState } from "react"
import { Table, Card, CardBody, Col, Row, Button, Input } from "reactstrap"

import { useNavigate } from "react-router-dom"
import Select from "react-select"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { DigitalServiceOptionsDrop } from "utils/common-options"
import moment from "moment"
import Loader from "pages/Separate/Loader"

const SEORankingRecord = () => {
  const [projectOptions, setProjectOptions] = useState([])
  const [project, setProject] = useState(null)
  const [keywords, setKeywords] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentTab, setCurrentTab] = useState(false)
  const [image, setImage] = useState("")
  const [extraKeywords, setExtraKeywords] = useState([])

  const [keywordDate, setKeywordDate] = useState(moment().format("YYYY-MM-DD"))
  const [localDate, setLocalDate] = useState(moment().format("YYYY-MM-DD"))
  const [trafficDate, setTrafficDate] = useState(moment().format("YYYY-MM-DD"))
  const [orderDate, setOrderDate] = useState(moment().format("YYYY-MM-DD"))

  const token = secureLocalStorage.getItem("token")

  /* ================= 4. PERFORMANCE – ORDERS ================= */
  const [ordersPerformance, setOrdersPerformance] = useState({
    totalOrders: { title: "Total Orders", value: "", subtitle: "", reason: "" },
    totalOrderValue: {
      title: "Total Order Value",
      value: "",
      subtitle: "",
      reason: "",
    },
    avgOrderValue: {
      title: "Avg Order Value",
      value: "",
      subtitle: "",
      reason: "",
    },
  })

  /* ================= 5. CAMPAIGN PERFORMANCE ================= */
  const [campaigns, setCampaigns] = useState([
    { title: "", description: "", link: null },
  ])

  const [performanceComparison, setPerformanceComparison] = useState([
    {
      metric: "Total Website Visits",
      current: "",
      last: "0",
      percentage: "",
      trend: "", // up / down
      fixed: true,
    },
    {
      metric: "Organic Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Direct Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Referral Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Time Spent on Site",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
  ])

  /* ================= 6. Local SEO PERFORMANCE ================= */
  const [localSeoPerformance, setLocalSeoPerformance] = useState([
    {
      google_buisness: "",
      interactions: "",
      calls: "",
      directions: "",
      Click: "",
      link: null,
    },
  ])

  const [isOrders, setIsOrders] = useState(false)

  // ================= API CALLING ===================
  // get projects list
  useEffect(() => {
    ; (async () => {
      try {
        const projectsRes = await fetchNodeData(
          null,
          `seoReport/getProjectKS`,
          token
        )

        const projectsOptions = (projectsRes.data || []).map(item => ({
          value: item.id,
          label: item.project_name,
          services: DigitalServiceOptionsDrop.filter(
            s =>
              (item.project_type || "")?.includes(s.value) &&
              (s.value == "1" || s.value == "3")
          ),
          seo_keywords: item.seo_keywords || "",
        }))
        setProjectOptions(projectsOptions)
      } catch (error) {
        console.log("Error Calling API : ", error)
      }
    })()
  }, [])

  // set keywords projectwise
  useEffect(() => {
    if (project) {
      setKeywords(
        project.seo_keywords
          ?.split(",")
          ?.filter(item => item)
          ?.map(keyword => ({ keyword: keyword, rank: "" })) || []
      )
    }
    console.log(project)
  }, [project])

  const updatePerformanceRow = (index, field, value) => {
    const updated = [...performanceComparison]
    updated[index][field] = value

    if (field === "current" || field === "last") {
      const { percentage, trend } = calculateChange(
        Number(updated[index].current),
        Number(updated[index].last)
      )
      updated[index].percentage = percentage
      updated[index].trend = trend
    }

    setPerformanceComparison(updated)
  }

  // upload images for local seo and campaigns
  // const handleUploadImage = async (e, setData, index) => {
  //   try {
  //     // const formData = new FormData()
  //     // formData.append("file", e.target.files[0])

  //     // const res2 = await axios.post(
  //     //   `${configure.nodeApi}/uploadImgToOneDrive`,
  //     //   formData
  //     // )

  //     // if (res2?.data?.success) {
  //     //   setData(prev => {
  //     //     return prev.map((item, i) => {
  //     //       if (i === index) item.link = res2?.data?.link || ""

  //     //       return item
  //     //     })
  //     //   })
  //     // }

  //     const imgUrl = URL.createObjectURL(e.target.files[0])

  //     setData(prev => {
  //       return prev.map((item, i) => {
  //         if (i === index) item.link = imgUrl || ""
  //         return item
  //       })
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // for traffic trend calculation
  // setImage(fileToBase64(e.target.files[0]))

  const fileToBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

  const handleUploadImage = async (e, setData, index) => {
    const file = e.target.files[0]
    if (!file) return

    const base64 = await fileToBase64(file)

    // save base64 wherever you want
    setData(prev => {
      return prev.map((item, i) => {
        if (i === index) item.link = base64 || ""
        return item
      })
    })
  }

  const handleNegativeValue = (section, key, field, value) => {
    setOrdersPerformance(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
        reason: value < 0 ? prev[key].reason : "",
      },
    }))
  }

  const calculateChange = (current, last) => {
    if (!current || !last || Number(last) === 0) {
      return { percentage: "", trend: "" }
    }

    const diff = ((current - last) / last) * 100
    return {
      percentage: Math.abs(diff).toFixed(2),
      trend: diff >= 0 ? "up" : "down",
    }
  }

  // save keywords ranking
  const handleSaveKeywordRanking = async () => {
    if (
      keywords.some(item => !item.rank) ||
      extraKeywords.some(item => item.keyword && !item.rank) ||
      extraKeywords.some(item => !item.keyword && !item.rank)
    ) {
      swal("", "Ranking for all keywords is required.", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save today's keyword ranking for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const formData = {
            id: project.value,
            keywordRanking: JSON.stringify(keywords),
            additionalKeyword: JSON.stringify(extraKeywords),
            date: keywordDate || moment().format("YYYY-MM-DD"),
          }
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addKeywordRanking`,
            token,
            formData
          )

          if (res?.data?.success) {
            // setProject(null)
            // setExtraKeywords([])
            swal("", "Ranking recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  // save Local SEo
  const handleSaveLocalSeo = async () => {
    if (
      localSeoPerformance.some(item => {
        return (
          !item.google_buisness.trim() ||
          !item.interactions.trim() ||
          !item.calls.trim() ||
          !item.directions.trim() ||
          !item.Click.trim() ||
          !item.link
        )
      })
    ) {
      swal("", "All data required!", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save today's Local SEO Performance for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const formData = {
            project_id: project.value,
            local_seo: localSeoPerformance,
            date: localDate || moment().format("YYYY-MM-DD"),
          }
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addLocalSeo`,
            token,
            formData
          )

          if (res?.data?.success) {
            setLocalSeoPerformance([
              {
                google_buisness: "",
                interactions: "",
                calls: "",
                directions: "",
                Click: "",
                link: null,
              },
            ])
            swal("", "Data recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  // save Traffic
  const handleSaveTraffic = async () => {
    if (performanceComparison.some(item => !item.current.trim())) {
      swal("", "All data required!", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save today's Traffic Comparison for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const formData = {
            project_id: project.value,
            visits: performanceComparison[0].current,
            organic: performanceComparison[1].current,
            direct: performanceComparison[2].current,
            referral: performanceComparison[3].current,
            time_spent: performanceComparison[4].current,
            image: image,
            date: trafficDate || moment().format("YYYY-MM-DD"),
          }
          console.log("Formdata", formData)
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addWebsiteTraffic`,
            token,
            formData
          )

          if (res?.data?.success) {
            setPerformanceComparison([
              {
                metric: "Total Website Visits",
                current: "",
                last: "130",
                percentage: "",
                trend: "", // up / down
                fixed: true,
              },
              {
                metric: "Organic Traffic",
                current: "",
                last: "78",
                percentage: "",
                trend: "",
                fixed: true,
              },
              {
                metric: "Direct Traffic",
                current: "",
                last: "22",
                percentage: "",
                trend: "",
                fixed: true,
              },
              {
                metric: "Referral Traffic",
                current: "",
                last: "30",
                percentage: "",
                trend: "",
                fixed: true,
              },
              {
                metric: "Time Spent on Site",
                current: "",
                last: "1.05",
                percentage: "",
                trend: "",
                fixed: true,
              },
            ])
            swal("", "Data recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  // save Orders
  const handleSaveOrders = async () => {
    if (false) {
      swal("", "Ranking for all keywords is required.", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save today's Order Performance for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const formData = {
            project_id: project.value,
            totalOrders: ordersPerformance.totalOrders,
            totalOrderValue: ordersPerformance.totalOrderValue,
            avgOrderValue: ordersPerformance.avgOrderValue,
            date: orderDate || moment().format("YYYY-MM-DD"),
          }
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addPerformaceReport`,
            token,
            formData
          )

          if (res?.data?.success) {
            setOrdersPerformance({
              totalOrders: {
                title: "Total Orders",
                value: "",
                subtitle: "",
                reason: "",
              },
              totalOrderValue: {
                title: "Total Order Value",
                value: "",
                subtitle: "",
                reason: "",
              },
              avgOrderValue: {
                title: "Avg Order Value",
                value: "",
                subtitle: "",
                reason: "",
              },
            })
            swal("", "Data recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  // save Local SEo
  const handleSaveCampaign = async () => {
    if (false) {
      swal("", "All Seo data is required.", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save today's Campaign for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const formData = {
            project_id: project.value,
            campaigns: campaigns,
            date: moment().format("YYYY-MM-DD"),
          }
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addCampain`,
            token,
            formData
          )

          if (res?.data?.success) {
            setCampaigns([{ title: "", description: "", link: null }])
            swal("", "Data recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  const minDate = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD")
  const maxDate = moment().format("YYYY-MM-DD")

  // console.log(project?.services)
  return (
    <>
      {loading && <Loader />}
      <Card className="mb-4 audit_box">
        <CardBody>
          <div>
            <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
              <h5 className="text-purple">SEO Keyword Ranking</h5>
            </div>

            <div className="row align-items-start">
              <div className="col-3">
                <label htmlFor="">Select Project</label>
                <Select
                  placeholder="Select Project"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={projectOptions}
                  value={project}
                  onChange={e => {
                    setProject(e)
                    if (e.services.length) setCurrentTab(e.services[0].value)
                  }}
                  required
                />
              </div>
              <div className="col-2">
                {project?.services && (
                  <div>
                    <label htmlFor="">Services</label>

                    <div className="d-flex gap-3 align-items-center">
                      {project?.services
                        ?.filter(item => item.value == "1")
                        ?.map(item => (
                          <div
                            key={item.value}
                            onClick={() => setCurrentTab(item.value)}
                            className={`px-4 py-2 rounded-pill bg-${currentTab == item.value ? "purple" : "white"
                              } fw-semibold`}
                            style={{ userSelect: "none", cursor: "pointer" }}
                          >
                            {item.label}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="col-6 text-end">
                {/* <button
                  onClick={handleSaveKeywordRanking}
                  type="button"
                  className=" btn text-white btn-save btn-label ms-3"
                >
                  <i className="fas fa-save me-2 icon-size label-icon"></i>
                  Save
                </button> */}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      {project && (
        <>
          {currentTab == "1" && (
            <>
              {/* KEYWORD POSITION SUMMARY */}
              <Card className="mb-4 audit_box">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-4">
                      <h5 className="mb-0 text-purple ">
                        Fixed Keyword & Ranking
                      </h5>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          value={keywordDate}
                          onChange={e => setKeywordDate(e.target.value)}
                          min={minDate}
                          max={maxDate}
                        />
                      </div>
                    </div>

                    <button
                      onClick={handleSaveKeywordRanking}
                      type="button"
                      className=" btn text-white btn-save btn-label ms-3"
                    >
                      <i className="fas fa-save me-2 icon-size label-icon"></i>
                      Save
                    </button>
                  </div>
                  {keywords.map((k, i) => (
                    <Row key={i} className="mb-2">
                      <Col md={6}>
                        <Input
                          placeholder="Keyword"
                          value={k.keyword}
                          readOnly
                        />
                      </Col>
                      <Col md={2}>
                        <Input
                          placeholder="Ranking"
                          type="number"
                          value={k.rank}
                          onChange={e => {
                            const updated = [...keywords]
                            updated[i].rank = e.target.value
                            setKeywords(updated)
                          }}
                        />
                      </Col>
                    </Row>
                  ))}

                  {!keywords.length && (
                    <span className="text-secondary">
                      No keyword available!
                    </span>
                  )}

                  <h5 className="mt-5 mb-3 text-purple ">
                    Any Additional Keyword & Ranking ?
                    <Button
                      color="primary"
                      onClick={() =>
                        setExtraKeywords([
                          ...extraKeywords,
                          { keyword: "", rank: "" },
                        ])
                      }
                      className="btn-dark border-0 ms-4 py-1"
                    >
                      <i className="fas fa-plus me-1"></i> Keyword
                    </Button>
                  </h5>
                  {extraKeywords.map((k, i) => (
                    <Row key={i} className="mb-2">
                      <Col md={6}>
                        <Input
                          placeholder="Keyword"
                          value={k.keyword}
                          onChange={e => {
                            const updated = [...extraKeywords]
                            updated[i].keyword = e.target.value

                            if (!e.target.value) {
                              updated[i].rank = ""
                            }

                            setExtraKeywords(updated)
                          }}
                        />
                      </Col>
                      <Col md={2}>
                        <Input
                          placeholder="Ranking"
                          type="number"
                          value={k.rank}
                          onChange={e => {
                            const updated = [...extraKeywords]
                            updated[i].rank = e.target.value
                            setExtraKeywords(updated)
                          }}
                          readOnly={!k.keyword}
                        />
                      </Col>
                      <Col md={4}>
                        <Button
                          color="danger"
                          onClick={() =>
                            setExtraKeywords(
                              extraKeywords.filter((_, idx) => idx !== i)
                            )
                          }
                          className="me-3 btn-red border-0"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </CardBody>
              </Card>

              {/* LOCAL SEO PERFORMANCE */}
              <Card className="mb-4 audit_box">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-4">
                      <h5 className="mb-0 text-purple ">
                        Local SEO Performance
                      </h5>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          value={localDate}
                          onChange={e => setLocalDate(e.target.value)}
                          min={minDate}
                          max={maxDate}
                        />
                      </div>
                    </div>

                    <button
                      onClick={handleSaveLocalSeo}
                      type="button"
                      className=" btn text-white btn-save btn-label ms-3"
                    >
                      <i className="fas fa-save me-2 icon-size label-icon"></i>
                      Save
                    </button>
                  </div>

                  <Table bordered className="bg-white">
                    <thead>
                      <tr>
                        <th>Google My Business</th>
                        <th className="col-1">Interaction</th>
                        <th className="col-1">Call</th>
                        <th className="col-1">Direction</th>
                        <th className="col-1">Click</th>
                        <th className="col-2">ScreenShot</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {localSeoPerformance.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <Input
                              value={row.google_buisness}
                              placeholder="Enter here.."
                              onChange={e => {
                                const updated = [...localSeoPerformance]
                                updated[i].google_buisness = e.target.value
                                setLocalSeoPerformance(updated)
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              value={row.interactions}
                              onChange={e => {
                                const updated = [...localSeoPerformance]
                                updated[i].interactions = e.target.value
                                setLocalSeoPerformance(updated)
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              value={row.calls}
                              onChange={e => {
                                const updated = [...localSeoPerformance]
                                updated[i].calls = e.target.value
                                setLocalSeoPerformance(updated)
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              value={row.directions}
                              onChange={e => {
                                const updated = [...localSeoPerformance]
                                updated[i].directions = e.target.value
                                setLocalSeoPerformance(updated)
                              }}
                            />
                          </td>
                          <td>
                            <Input
                              value={row.Click}
                              onChange={e => {
                                const updated = [...localSeoPerformance]
                                updated[i].Click = e.target.value
                                setLocalSeoPerformance(updated)
                              }}
                            />
                          </td>
                          <td className="d-flex gap-3 align-items-center">
                            <input
                              type="file"
                              className="form-control"
                              onChange={e =>
                                handleUploadImage(e, setLocalSeoPerformance, i)
                              }
                            />
                            {row.link ? (
                              <img src={row.link} width={30} height={30} />
                            ) : null}
                          </td>
                          <td className="col-2">
                            {i !== 0 && (
                              <Button
                                color="danger"
                                onClick={() =>
                                  setLocalSeoPerformance(
                                    localSeoPerformance.filter(
                                      (_, idx) => idx !== i
                                    )
                                  )
                                }
                                className="me-3 btn-red border-0"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            )}

                            {i == localSeoPerformance.length - 1 && (
                              <Button
                                color="primary"
                                onClick={() =>
                                  setLocalSeoPerformance([
                                    ...localSeoPerformance,
                                    {
                                      google_buisness: "",
                                      interactions: "",
                                      calls: "",
                                      directions: "",
                                      Click: "",
                                      link: null,
                                    },
                                  ])
                                }
                                className="btn-purple border-0"
                              >
                                <i className="fas fa-plus me-1"></i> New
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>

              <Card className="mb-4 audit_box">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-4">
                      <h5 className="mb-0 text-purple ">
                        Website Traffic Comparison from Last Month
                      </h5>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          value={trafficDate}
                          onChange={e => setTrafficDate(e.target.value)}
                          min={minDate}
                          max={maxDate}
                        />
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                      <div className="">
                        <input
                          type="file"
                          className="form-control"
                          style={{ width: "250px" }}
                          onChange={async e => {
                            const file = e.target.files[0]
                            if (file) {
                              const baseimage = await fileToBase64(file)
                              setImage(baseimage)
                            }
                          }}
                        />
                      </div>
                      {image ? (
                        <img src={image} width={30} height={30} />
                      ) : null}
                      <div>
                        <button
                          onClick={handleSaveTraffic}
                          type="button"
                          className=" btn text-white btn-save btn-label ms-3"
                        >
                          <i className="fas fa-save me-2 icon-size label-icon"></i>
                          Save
                        </button>
                      </div>
                    </div>
                  </div>

                  <Table bordered responsive className="bg-white">
                    <thead>
                      <tr>
                        <th>Metric</th>
                        <th className="col-2">Current Month</th>
                        {/* <th className="col-1">Last Month</th>
                        <th className="col-1">Change %</th>
                        <th className="col-1 text-center">Trend</th> */}
                        {/* <th></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {performanceComparison.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <Input
                              value={row.metric}
                              disabled={row.fixed}
                              onChange={e =>
                                updatePerformanceRow(
                                  i,
                                  "metric",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <Input
                              type="text"
                              value={row.current}
                              onChange={e =>
                                updatePerformanceRow(
                                  i,
                                  "current",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          {/* <td>
                            <Input
                              type="text"
                              value={row.last}
                              readOnly
                              onChange={e =>
                                updatePerformanceRow(i, "last", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <Input value={row.percentage || "--"} readOnly />
                          </td>

                          <td className="text-center fs-5">
                            {row.trend === "up" && (
                              <span style={{ color: "green" }}>↑</span>
                            )}
                            {row.trend === "down" && (
                              <span style={{ color: "red" }}>↓</span>
                            )}
                          </td> */}

                          {/* <td className="col-2">
                                          {!row.fixed && (
                                            <Button
                                              color="danger"
                                              onClick={() =>
                                                setPerformanceComparison(
                                                  performanceComparison.filter(
                                                    (_, idx) => idx !== i
                                                  )
                                                )
                                              }
                                              className="me-3 btn-red border-0"
                                            >
                                              <i className="fas fa-trash"></i>
                                            </Button>
                                          )}
              
                                          {i == performanceComparison.length - 1 && (
                                            <Button
                                              color="primary"
                                              onClick={() =>
                                                setPerformanceComparison([
                                                  ...performanceComparison,
                                                  {
                                                    metric: "",
                                                    current: "",
                                                    last: "0",
                                                    percentage: "",
                                                    trend: "",
                                                    fixed: false,
                                                  },
                                                ])
                                              }
                                              className="btn-purple border-0"
                                            >
                                              <i className="fas fa-plus me-1"></i> Metric
                                            </Button>
                                          )}
                                        </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </>
          )}

          {/* PERFORMANCE BREAKDOWN */}
          {currentTab == "3" && (
            <Card className="mb-4 audit_box">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className=" text-purple ">
                    Performance Breakdown of All Campaigns
                  </h5>

                  <button
                    onClick={handleSaveCampaign}
                    type="button"
                    className=" btn text-white btn-save btn-label ms-3"
                  >
                    <i className="fas fa-save me-2 icon-size label-icon"></i>
                    Save
                  </button>
                </div>

                <Table bordered className="bg-white">
                  <thead>
                    <tr>
                      <th>Campaign</th>
                      <th>Description</th>
                      <th className="col-3">ScreenShot</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.map((row, i) => (
                      <tr key={i}>
                        <td>
                          <Input
                            value={row.title}
                            placeholder="Enter title"
                            onChange={e => {
                              const updated = [...campaigns]
                              updated[i].title = e.target.value
                              setCampaigns(updated)
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            placeholder="Enter description"
                            value={row.description}
                            onChange={e => {
                              const updated = [...campaigns]
                              updated[i].description = e.target.value
                              setCampaigns(updated)
                            }}
                          />
                        </td>
                        <td className="d-flex gap-3 align-items-center">
                          <Input
                            type="file"
                            onChange={e =>
                              handleUploadImage(e, setCampaigns, i)
                            }
                          />
                          {row.link ? (
                            <img src={row.link} width={30} height={30} />
                          ) : null}
                        </td>
                        <td className="col-2">
                          {i !== 0 && (
                            <Button
                              color="danger"
                              onClick={() =>
                                setCampaigns(
                                  campaigns.filter((_, idx) => idx !== i)
                                )
                              }
                              className="me-3 btn-red border-0"
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          )}

                          {i == campaigns.length - 1 && (
                            <Button
                              color="primary"
                              onClick={() =>
                                setCampaigns([
                                  ...campaigns,
                                  {
                                    title: "",
                                    description: "",
                                    link: null,
                                  },
                                ])
                              }
                              className="btn-purple border-0"
                            >
                              <i className="fas fa-plus me-1"></i> Campaign
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          )}

          {/* PERFORMANCE – ORDERS */}
          <Card className="mb-4 audit_box">
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-semibold text-purple mb-3 d-flex gap-4">

                  <div className="d-flex align-items-center gap-4">
                    <h5 className="mb-0 text-purple ">
                      Performance – Primary Goal: Orders
                    </h5>
                    <div>
                      <input
                        type="date"
                        className="form-control"
                        value={orderDate}
                        onChange={e => setOrderDate(e.target.value)}
                        min={minDate}
                        max={maxDate}
                      />
                    </div>
                  </div>

                  <div className="form-switch form-switch-md">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isOrders}
                      onClick={e => {
                        setIsOrders(!e.target.checked)
                      }}
                    />
                  </div>
                </h5>
                {isOrders && (
                  <button
                    onClick={handleSaveOrders}
                    type="button"
                    className=" btn text-white btn-save btn-label ms-3"
                  >
                    <i className="fas fa-save me-2 icon-size label-icon"></i>
                    Save
                  </button>
                )}
              </div>
              {isOrders
                ? Object.entries(ordersPerformance).map(([key, data]) => (
                  <Row key={key} className="mb-3">
                    <Col md={2}>
                      <h5 className="mb-0 pt-2">{data.title}</h5>
                    </Col>

                    <Col md={2}>
                      <Input
                        type="number"
                        placeholder="Value"
                        value={data.value}
                        onChange={e =>
                          handleNegativeValue(
                            "orders",
                            key,
                            "value",
                            e.target.value
                          )
                        }
                      />
                    </Col>

                    <Col md={4}>
                      <Input
                        placeholder="Subtitle"
                        value={data.subtitle}
                        onChange={e =>
                          setOrdersPerformance(prev => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              subtitle: e.target.value,
                            },
                          }))
                        }
                      />
                    </Col>

                    {data.value < 0 && (
                      <Col md={4}>
                        <Input
                          placeholder="Reason for negative value"
                          value={data.reason}
                          onChange={e =>
                            setOrdersPerformance(prev => ({
                              ...prev,
                              [key]: {
                                ...prev[key],
                                reason: e.target.value,
                              },
                            }))
                          }
                        />
                      </Col>
                    )}
                  </Row>
                ))
                : null}
            </CardBody>
          </Card>
        </>
      )}
    </>
  )
}

export default SEORankingRecord
